import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['modal', 'progressBar', 'result']
  connect() {
  }

  correction() {
    this.animateProgressBar();
  }

  animateProgressBar() {
    setTimeout(() => {
      this.progressBarTarget.style.width = '100%';
    }, 1000);

    // setTimeout(() => {
    //   this.progressBarTarget.style.width = '0%';
    // }, 60000);

    setTimeout(() => {
      this.resultTarget.style.display = '';
    }, 41000);
  }
}